import { Outlet } from 'react-router-dom'
import { TapBrand } from '@/components/layout/TapBrand'
import { env } from '@/config/env'

const FEATURES = [
  { dot: 'bg-success', text: '4 gateways · 14 assets connected live', pulse: true },
  { dot: 'bg-accent', text: 'Real-time OEE, energy & alarm intelligence', pulse: false },
  { dot: 'bg-warning', text: 'TAP Copilot — ask anything about your plant', pulse: false },
] as const

/**
 * Unauthenticated shell: a centered two-panel card over a dotted backdrop.
 * Left panel carries TAP branding; the right panel renders the active auth page
 * (login / forgot / reset) via <Outlet>. Layout mirrors the demo login screen.
 */
export function AuthLayout() {
  return (
    <div className="dot-grid flex min-h-screen w-full items-center justify-center bg-bg-base p-5">
      <div className="grid w-full max-w-[920px] grid-cols-1 overflow-hidden rounded-2xl border border-border-subtle bg-bg-surface shadow-2xl md:grid-cols-[1.1fr_1fr]">
        {/* Branding panel */}
        <div className="hidden flex-col justify-between border-r border-border-subtle bg-gradient-to-br from-bg-elevated to-bg-surface p-10 md:flex">
          <div>
            <TapBrand />
            <div className="mt-1.5 text-xs tracking-[0.04em] text-text-muted">
              Things, Analytics &amp; Predictions
            </div>
          </div>

          <div className="mt-10">
            <div className="text-[22px] font-semibold leading-snug text-text-primary">
              Mission control for your industrial floor.
            </div>
            <div className="mt-3 text-[13px] leading-relaxed text-text-secondary">
              Real-time telemetry, predictive alerts, and AI-assisted operations — unified across
              every gateway, machine, and shift.
            </div>

            <div className="mt-7 flex flex-col gap-2.5">
              {FEATURES.map((f) => (
                <div key={f.text} className="flex items-center gap-2.5 text-xs text-text-secondary">
                  <span
                    className={`h-1.5 w-1.5 shrink-0 rounded-full ${f.dot} ${f.pulse ? 'animate-pulse_dot' : ''}`}
                  />
                  <span>{f.text}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="mt-10 text-[11px] leading-relaxed text-text-muted">
            {env.VITE_APP_NAME} — Industrial IoT Platform
            <br />
            Platform by ZyxanTech, Hyderabad
          </div>
        </div>

        {/* Form panel */}
        <div className="flex flex-col justify-center p-10">
          <Outlet />
        </div>
      </div>
    </div>
  )
}
